import { StateCode, StateEntity } from "state/types";
import { getCookie } from "utils";

const CURRENT_STATE_COOKIE_NAME = "clinic-sel-state";

// This implementation is copied from existing code:
// https://code.amazon.com/packages/KataraDetailPageWebAppAssets/blobs/mainline/--/src/js/storage.ts
const EXPIRE_TIME = 7 * 24 * 60 * 60 * 1000; // ms
const STATE_LOCAL_STORAGE_KEY = "amzn1.katara.localStorage.location";

interface LegacyState {
    readonly name?: string
    readonly value?: StateCode
    readonly expire?: number
}
export const getSelectedState: () => StateCode | undefined = () => {
    const state = getCookie(CURRENT_STATE_COOKIE_NAME);
    if (!!state) {
        return state;
    }

    const legacyState = JSON.parse(window.localStorage.getItem(STATE_LOCAL_STORAGE_KEY) ?? "{}") as LegacyState;
    if (Date.now() > (legacyState.expire ?? 0)) {
        window.localStorage.removeItem(STATE_LOCAL_STORAGE_KEY);
        return;
    }
    return legacyState.value
}


export const setSelectedState = (state?: StateEntity) => {
    if (!state) {
        return;
    }
    // TODO implement cookie based selection
    // https://issues.amazon.com/issues/KATARA-SX-4707
    const stateSaved: LegacyState = {
        name: state.label,
        value: state.stateCode,
        expire: Date.now() + EXPIRE_TIME,
    }
    window.localStorage.setItem(STATE_LOCAL_STORAGE_KEY, JSON.stringify(stateSaved));
}